import styled, { keyframes } from 'styled-components';

import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Button from '@mui/material/Button';
import React from 'react';
import TagManager from 'react-gtm-module';
import Tooltip from '@mui/material/Tooltip';
import checked from '../assets/images/check.png';
import classes from './ListItem.module.css';
import star_mask from '../assets/images/star_mask.png';
import { useWindowSize } from '../hooks/useWindowSize';

const ListItem = ({
    key,
    id,
    index,
    name,
    apy,
    logo,
    advertiser_notes,
    phone,
    link,
    rating,
    effective_at,
    member,
    min_to_open,
    term,
}) => {
    const window_size = useWindowSize();
    const [state, setState] = React.useState({
        is_show_more: false,
        is_mobile_show_detail: true,
        is_show_arrow: false,
    });

    const [showDetails, setShowDetails] = React.useState(false);

    const handleToggleDetails = () => {
        setShowDetails(!showDetails);
    };

    const handleToggleButtonArrowIcon = () => {
        setState((state) => ({...state, is_show_arrow: !state.is_show_arrow}));
    };

    const handleTraceInfo = () => {
        const tagManagerArgs = {
            dataLayer: {
                lender_name: `${name}`,
                product_name: 'CD',
                event: 'bankrateCdsClick',
            },
        };
        TagManager.dataLayer(tagManagerArgs);
        console.log(link);
        window.open(link, '_blank');
    };

    const handleTraceInfoLink = () => {
        const tagManagerArgs = {
            dataLayer: {
                lender_name: `${name}`,
                product_name: 'CD',
                event: 'bankrateCdsClick',
            },
        };
        TagManager.dataLayer(tagManagerArgs);
    };

    let complianceText = 'CD';
    if (name.toLowerCase().includes('cage point dba')) {
        complianceText = 'ANNUITY';
    }

    React.useEffect(() => {
        if (window_size[0] > 515) {
            setState((state) => ({...state, is_mobile_show_detail: true}));
        }
    }, [window_size]);

    return (
        <ListItemContainer key={id}>
            <ComplianceTag>
                <ComplianceTagText>{complianceText}</ComplianceTagText>
            </ComplianceTag>
            <MainContainer>
                <ListItemLeft>
                    <ListItemLeftLogoContainer>
                        <ListItemLeftLogo
                            src={`https://www.brimg.net/system/img/inst/${logo}`}
                        />
                    </ListItemLeftLogoContainer>
                </ListItemLeft>
                <ListItemMiddle>
                    <ContentPreviewContainer>
                        <ContentPreviewContainerItem>
                            <ContentPreviewImage src={checked} />
                            <ContentPreviewContainerItemText>
                                <span>{apy.toFixed(2)}</span>{' '}
                                <Tooltip
                                    title={
                                        'APY, or annual percentage yield, is the yearly return on a bank or investment account.'
                                    }
                                >
                                    <span className='underline'>{'APY'}</span>
                                </Tooltip>{' '}
                                {`(as of ${effective_at})`}
                            </ContentPreviewContainerItemText>
                        </ContentPreviewContainerItem>
                        <ContentPreviewContainerItem>
                            <ContentPreviewImage src={checked} />
                            <ContentPreviewContainerItemText>
                                Min. Deposit: ${min_to_open}
                            </ContentPreviewContainerItemText>
                        </ContentPreviewContainerItem>
                        <ContentPreviewContainerItem>
                            <ContentPreviewImage src={checked} />
                            <ContentPreviewContainerItemText>
                                Term: {term}
                            </ContentPreviewContainerItemText>
                        </ContentPreviewContainerItem>
                    </ContentPreviewContainer>
                </ListItemMiddle>
                <ListItemRight>
                    <ViewRateButton
                        onMouseEnter={handleToggleButtonArrowIcon}
                        onMouseLeave={handleToggleButtonArrowIcon}
                        endIcon={
                            state.is_show_arrow ? <ArrowForwardIcon /> : null
                        }
                        is_show_arrow={state.is_show_arrow}
                        onClick={handleTraceInfo}
                    >
                        view rate
                    </ViewRateButton>
                    <PhoneButtonContainer
                        is_show={phone}
                        onClick={() => {
                            window.open(`tel:${phone}`);
                        }}
                    ></PhoneButtonContainer>
                </ListItemRight>
            </MainContainer>
            <ContentResultContainer>
                <ListItemLeftStarsListContainer rating={rating}>
                    <MemberText>Member {member}</MemberText>
                    <ListItemLeftStarsFilledListContainer>
                        <ListItemLeftStarsFilledListStarMask
                            src={star_mask}
                            alt={'star_mask'}
                        />
                        <ListItemLeftStarsFilled
                            width={(rating / 5) * 50}
                            color={'#339cde'}
                            z_index={2}
                        />
                        <ListItemLeftStarsFilled
                            width={50}
                            color={'#e9f5ff'}
                            z_index={1}
                        />
                    </ListItemLeftStarsFilledListContainer>
                    <ListItemLeftStarsFilledListTextContainer>
                        <Tooltip
                            title={
                                'Bankrate scores are objectively determined by our editorial team. Our scoring formula weighs several factors consumers should consider when choosing financial products and services.'
                            }
                        >
                            <ListItemLeftStarsFilledListText>
                                {rating}
                            </ListItemLeftStarsFilledListText>
                        </Tooltip>
                    </ListItemLeftStarsFilledListTextContainer>
                </ListItemLeftStarsListContainer>
                <ContentResultContainerText>
                    Promoted Offer{' '}
                    {advertiser_notes && (
                        <div>
                            :{' '}
                            <a
                                href={link}
                                target='_blank'
                                rel='noreferrer'
                                onClick={handleTraceInfoLink}
                            >
                                {advertiser_notes}
                            </a>
                        </div>
                    )}
                </ContentResultContainerText>
            </ContentResultContainer>
            <HorizontalLine />
            <div className={classes.detailsBox} onClick={handleToggleDetails}>
                <p className={classes.detailsLink}>Offer Details</p>
                <ArrowDownwardOutlinedIcon fontSize='small' />
            </div>
            {showDetails && (
                <div className={classes.detailsContainer}>
                    <h4>Product details</h4>
                    <p>
                        Offer valid as of: <span>{effective_at}</span>
                    </p>
                    <hr />
                    <p>
                        Minimum deposit: <span>${min_to_open}</span>
                    </p>
                    {advertiser_notes && (
                        <>
                            <h4>Current promotion</h4>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: advertiser_notes,
                                }}
                            />
                        </>
                    )}
                </div>
            )}
        </ListItemContainer>
    );
};

const ComplianceTag = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
`;

const ComplianceTagText = styled.p`
    background-color: #e0f7fa;
    color: #00796b;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    margin: 0;
    letter-spacing: 2px;
`;

const HorizontalLine = styled.div`
    width: 100%;
    height: 1px;
    margin-top: 5px;
    background-color: #ddd;
`;

const ListItemContainer = styled.div`
    width: 100%;
    box-shadow: 5px 5px 16px rgb(0 0 0 / 30%);
    background-color: #fff;
    overflow: hidden;
    border: 1px solid #ddd;
    min-height: 195px;
    margin: 15px 0px;
    position: relative;
`;

const MainContainer = styled.div`
    margin: 15px 15px 0 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 660px) {
        flex-direction: column;
        margin: 20px 0px;
    }
`;

const ListItemLeft = styled.div`
    display: flex;
    justify-content: center;
    align-self: center;
    flex-direction: column;
    @media (max-width: 660px) {
        width: 100%;
    }
`;

const ListItemLeftLogoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-self: center;
    width: 150px;
`;

const ListItemLeftLogo = styled.img`
    width: 100%;
`;

const ListItemLeftStarsListContainer = styled.div`
    display: ${(p) => (p.rating ? 'flex' : 'none')};
    align-items: center;
    width: 100%;
`;

const ListItemLeftStarsFilledListContainer = styled.div`
    position: relative;
    width: 65px;
    height: 15px;
    display: flex;
    align-items: center;

    @media (max-width: 660px) {
        display: none;
    }
`;

const ListItemLeftStarsFilledListTextContainer = styled.div``;

const ListItemLeftStarsFilledListText = styled.p`
    font-size: 14px;
    margin: 0;
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer;

    @media (max-width: 660px) {
        display: none;
    }
`;

const ListItemLeftStarsFilledListStarMask = styled.img`
    position: absolute;
    width: 55px;
    height: 15px;
    top: 0px;
    left: 8px;
    z-index: 3;
    @media (max-width: 660px) {
        top: 0px;
        left: calc(50% - 90px);
    }
`;

const ListItemLeftStarsFilled = styled.div`
    position: absolute;
    width: ${(p) => `${p.width}px`};
    height: 15px;
    top: 0px;
    left: 10px;
    background-color: ${(p) => p.color};
    z-index: ${(p) => p.z_index};
    @media (max-width: 660px) {
        top: 0px;
        left: calc(50% - 90px);
    }
`;

const ListItemMiddle = styled.div`
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    @media (max-width: 660px) {
        width: 90%;
        margin: 0px 5%;
        align-items: flex-start;
    }
`;

const ContentPreviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    @media (max-width: 660px) {
        padding: 20px 0px 10px 0px;
        width: 97.5%;
        margin: 0px 1.25%;
    }
`;

const ContentPreviewContainerItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ContentPreviewContainerItemText = styled.p`
    margin: 2.5px 0 2.5px 5px;
    font-size: 15px;
    font-weight: 400;

    .underline {
        text-decoration: underline;
        cursor: pointer;
    }

    > span {
        font-size: 20px;
        font-weight: 600;
    }

    @media (max-width: 660px) {
        font-size: 12px;
        font-weight: 400;

        > span {
            font-size: 15px;
        }

        .underline {
            text-decoration: none;
            cursor: none;
        }
    }
`;

const ContentResultContainer = styled.div`
    width: 100%;
    margin-left: 15px;
    display: flex;
    flex-direction: column;
    padding-top: 20px;

    @media (max-width: 660px) {
        padding-bottom: 10px;
        width: 100%;
        margin-left: 15px;
    }
`;

const color_change = keyframes`
  10% {
    color: #2c99dd;
  }

  50% {
    color: #6FB3DE;
  }

  100% {
    color: #2c99dd;
  }
`;

const ContentResultContainerText = styled.p`
    font-size: 14px;
    margin: 2.5px 0px;
    font-weight: 600;
    display: flex;

    > a {
        font-weight: 400;
        text-decoration: none;
        animation: ${color_change} 2s infinite;
        color: #6fb3de;
        transition: color 2s ease;
    }
`;

const MemberText = styled.p`
    font-size: 14px;
    margin: 2.5px 0px;
    font-weight: 600;

    > a {
        font-weight: 400;
        text-decoration: none;
        animation: ${color_change} 2s infinite;
        color: #6fb3de;
        transition: color 2s ease;
    }
`;

const ListItemRight = styled.div`
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (max-width: 660px) {
        width: 100%;
    }
`;

const slide_in = keyframes`
  from {
    width: 0px;
  }

  to {
    width: 20px;
  }
`;

const slide_out = keyframes`
  from {
    width: 20px;
  }

  to {
    width: 0px;
  }
`;

const ViewRateButton = styled(Button)`
    background-color: #2da83e !important;
    border-radius: 0;
    text-transform: uppercase;
    font-family: 'Outfit', sans-serif;
    width: 140px;
    height: 50px;
    transition: 0.5s;
    color: #fff !important;

    .MuiButton-endIcon {
        width: ${(p) => (p.is_show_arrow ? '20px' : '0px')};
        height: 20px;
        animation: ${(p) => (p.is_show_arrow ? slide_in : slide_out)} 0.2s
            linear;
    }

    &:hover {
        box-shadow: 0px 0px 0px 5px rgba(0, 0, 0, 0.2);
        transition: 0.5s;
    }
`;

const PhoneButtonContainer = styled.div`
    display: ${(p) => (p.is_show ? 'flex' : 'none')};
    border: 1px solid #098b1e;
    transition: 0.2s;
    cursor: pointer;
    flex-direction: column;
    width: 140px;
    height: 45px;
    justify-content: space-around;
    align-items: center;
    margin-top: 10px;
`;

const ContentPreviewImage = styled.img`
    width: 15px;
`;

export default ListItem;
